.mention {
  padding: 0.25rem 0;

  & + & {
    border-top: 1px solid var(--gray-300);
  }
}
